import 'css-chunksrc/client/pages/documentsPage/reportsPage/filterForm/styles.scss';export default {
  "filters": "_filters_1tdm5_1",
  "resetButton": "_resetButton_1tdm5_9",
  "label": "_label_1tdm5_17",
  "section": "_section_1tdm5_23"
};